import { styled } from '@slal/ui';
import { P } from '@slal/ui/typography';

export const CheckboxTextAreaBlock = styled.div`
    padding: ${({ theme }) => theme.space[4]} 0;
`;

export const CheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding-bottom: ${({ theme }) => theme.space[4]};
    max-width: 100%;
`;

export const CharacterCount = styled(P)`
    margin-top: 4px;
    font-size: 14px;
    margin-bottom: 15px;
    color: ${({ theme }) => theme.colors.neutral__light__70};
`;
